// import { Config } from "tailwindcss";

import { T_SetThemeProps } from "@/types/app.type";

/**
 * Name: setTheme
 * 
 * Description: sets default themes for the styled component passed in the argument, sets media-queries wherever applicable for responsive view
 *
 *  @param param0 object that contains the following properties:
 *                - component: name of the component to which themes are to be applied
 *                - theme: the default themes object to apply styles from
 * 
 * @returns an object containing CSS styles to be applied as a default theme for styled components
 */
export const setTheme = ({ component = "", theme }: T_SetThemeProps) => {

    /** defining screen size for breakpoints */
    const screens: any = theme?.screens || {
        'xs': '0px',
        'sm': '640px',
        'md': '768px',
        'lg': '1024px',
        'xl': '1280px',
        'xxl': '1536px',
        '2xl': '1536px',
    }

    /** contains CSS styles as defined in default themes */
    let themeStyles: any = {};

    for (const key in theme?.[component]) {
        if (screens?.hasOwnProperty(key)) {
            themeStyles[`@media (min-width:${screens[key]})`] = theme?.[component]?.[key];
        } else {
            themeStyles[key] = theme?.[component]?.[key];
        }
    }
    return themeStyles;
}

export const setPropsStyle = (props: any = {}) => {
    const styleAttributes: string[] = [
        "height",
        "minHeight",
        "maxHeight",
        "width",
        "minWidth",
        "maxWidth"
    ]
    let styles: any = {};
    for(const key in props) {
        if(styleAttributes.includes(key)) {
            styles[key] = props[key];
        }
    }
    return styles;
}